module.exports = __webpack_public_path__ + "img/women_old.837a3ef4.png";